import { render, staticRenderFns } from "./termlyContent.vue?vue&type=template&id=5c04d614&scoped=true"
import script from "./termlyContent.vue?vue&type=script&lang=js"
export * from "./termlyContent.vue?vue&type=script&lang=js"
import style0 from "./termlyContent.vue?vue&type=style&index=0&id=5c04d614&prod&lang=scss&scoped=true"
import style1 from "./termlyContent.vue?vue&type=style&index=1&id=5c04d614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04d614",
  null
  
)

export default component.exports